<div class="filter-container">
  <results-filters-box
    id="filters"
    [filters]="filters"
    (componentFocus)="componentFocusedFinish.emit($event)"
    (filterChange)="onFilterChange($event)"
    [enableClearAll]="true"
    (clearAll)="clearAllFilters()"
    (onValuesUpdated)="onFilterValuesSearchDone($event)"
  >
  </results-filters-box>
  <collection-save
    [collection]="collection"
    [state]="state"
    [layoutMode]="layoutMode"
    (onStateChanged)="onStateChanged()"
    (onSave)="onSave()"
    (onLayoutModeChanged)="layoutMode = $event"
    [showSaveButton]="isFiltersChanged"
  >
  </collection-save>
</div>
<div class="results-container">
  <search-results-list
    [loading]="loading"
    [displayedContext]="displayedContext$ | async"
    [items]="items$ | async"
    [emptyResults]="emptyResults$ | async"
    (nextPage)="nextPage($event)"
    [componentFocused]="componentFocused === CollectionsComponentFocused.RESULTS"
    (componentFocusedFinish)="componentFocusedFinish.emit($event)"
    [listView]="{ limitResults: true }"
    [listName]="'collections'"
    pageType="live-collection"
    [searchId]="searchId"
    [layoutMode]="searchParamsService.layoutMode || layoutMode"
    (viewModeChanged)="onViewModeChanged()"
    [updateHeight]="updateHeight"
  >
  </search-results-list>
</div>
